import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=94e3c4f6"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports